import { useState } from 'react'
import { useMount } from 'ahooks'
import { useNavigate } from 'react-router'
import { useParams } from 'react-router-dom'
import Icon from '@/components/Icon/Icon'
import SearchBar from '@/pages/Album/components/SearchBar'
import Products from '@/pages/Album/components/Products'
import { routesMap, utils, common, uploadCommonEt } from '@/utils'
import styles from './index.module.less'
import Tabbar from '@/pages/Album/components/Tabbar'
import HomeShare from '../components/Share/HomeShare'
import usePageTitle from '@/hooks/usePageTitle'
import useQueryParams from '@/hooks/useQueryParams'
import useDisableBodyScroll from '@/hooks/useDisableBodyScroll'

const { isWebview } = utils
const { getApiByAppEnv } = common

function Album() {
  const navigate = useNavigate()
  const { productIdKey, isShare } = useQueryParams()
  const { corpId } = useParams() as Record<string, string>
  const [searchText, setSearchText] = useState('')
  const [homeShareVisible, setHomeShareVisible] = useState(false)
  useDisableBodyScroll(homeShareVisible)
  usePageTitle()
  function openMenuModal() {
    if (
      window.webview?.openDrawerMenu &&
      typeof window.webview.openDrawerMenu === 'function'
    )
      window.webview.openDrawerMenu()
  }

  // 切换语言
  function onSwitchLanguage() {
    navigate(routesMap.LangSetting)
  }

  // 分享页面
  function onSharePage() {
    setHomeShareVisible(true)
  }

  getApiByAppEnv()

  // 7.8.3需求埋点：通过分享链接进入商品列表页
  useMount(() => {
    if (isShare === '1') {
      uploadCommonEt(12)
    }
  })

  return (
    <div className={styles['home-wrap']}>
      {/* 搜索栏 */}
      <div className={styles['searchbar-box']}>
        {isWebview() ? (
          <Icon
            name="menu"
            className={styles['more-menu']}
            size={44}
            color="white"
            onClick={openMenuModal}
          />
        ) : (
          <Icon
            name="switch-lang"
            className={styles['more-menu']}
            size={48}
            color="white"
            onClick={onSwitchLanguage}
          />
        )}

        <SearchBar
          className={styles['search-bar']}
          customizeStyle={{
            backgroundColor: 'white',
          }}
          onSearch={setSearchText}
        />

        <Icon
          name="share"
          className={styles['more-menu']}
          size={48}
          color="white"
          onClick={onSharePage}
        />
      </div>

      {/* 商品列表 */}
      <div className={styles['product-list']}>
        <Products
          corpId={corpId}
          codeId={productIdKey}
          searchText={searchText}
        />
      </div>

      {homeShareVisible && (
        <HomeShare
          onClose={() => {
            setHomeShareVisible(false)
          }}
        />
      )}

      <Tabbar />
    </div>
  )
}

export default Album
